import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in");
      navigate("/login");
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-page" className="min-h-screen pt-28 pb-20 px-6 flex flex-col items-center bg-sand">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo tone="dark" className="h-16 w-auto mx-auto" />
        </div>
        {!token ? (
          <div className="text-center" data-testid="reset-invalid">
            <h1 className="font-serif text-3xl font-light">Invalid link</h1>
            <p className="text-charcoal/60 mt-3 text-sm">This reset link is missing or malformed.</p>
            <Link to="/forgot-password" className="overline inline-block mt-6 hover:opacity-60">Request a new link</Link>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-3xl font-light text-center mb-8">Set a new password</h1>
            <form onSubmit={submit} className="space-y-6">
              <div>
                <label className="overline text-charcoal/60">New password</label>
                <input
                  data-testid="reset-password"
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-transparent border-b border-charcoal/30 py-2.5 focus:outline-none focus:border-charcoal"
                />
              </div>
              <div>
                <label className="overline text-charcoal/60">Confirm password</label>
                <input
                  data-testid="reset-confirm"
                  type="password"
                  required
                  minLength={8}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="w-full bg-transparent border-b border-charcoal/30 py-2.5 focus:outline-none focus:border-charcoal"
                />
              </div>
              <button data-testid="reset-submit" disabled={busy} className="w-full bg-ocean text-sand py-4 overline hover:opacity-90 transition-opacity disabled:opacity-50">
                {busy ? "Updating…" : "Update password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
